import React from "react"
import { SectionContainer, Wrapper, Head, Left, Right, Title, Body, ViewAll, ScrollerContainer, Count } from "./styles/section"
import { Container } from "../../containers"

export default function Section({ children, bg, ...rest }) {
  return (
    <SectionContainer {...rest} bg={bg}>
      <Container>{children}</Container>
    </SectionContainer>
  )
}

Section.Wrapper = function SectionWrapper({ children, ...rest }) {
  return <Wrapper {...rest}>{children}</Wrapper>
}

Section.Head = function SectionHead({ children, ...rest }) {
  return <Head {...rest}>{children}</Head>
}

Section.Left = function SectionLeft({ children, ...rest }) {
  return <Left {...rest}>{children}</Left>
}

Section.Right = function SectionRight({ children, ...rest }) {
  return <Right {...rest}>{children}</Right>
}
Section.ViewAll = function SectionViewAll({ children, to, ...rest }) {
  return (
    <ViewAll {...rest} to={to}>
      {children}
    </ViewAll>
  )
}

Section.Title = function SectionTitle({ children, ...rest }) {
  return <Title {...rest}>{children}</Title>
}

Section.Count = function SectionCount({ children, ...rest }) {
  return <Count {...rest}>{children}</Count>
}

Section.Body = function SectionBody({ children, ...rest }) {
  return <Body {...rest}>{children}</Body>
}

Section.ScrollContainer = function Scroll({ children, ...rest }) {
  return <ScrollerContainer {...rest}>{children}</ScrollerContainer>
}
